import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { VOUCHER_TYPE_USAGE } from 'src/features/voucherTypes/utils/types';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';

export const VOUCHER_USAGE_BADGE_OPTIONS: Record<VOUCHER_TYPE_USAGE, BadgeOption> = {
    [VOUCHER_TYPE_USAGE.SINGLE]: {
        label: voucherTypesMessages.single,
        icon: ICON_MAP.SINGLE,
        theme: 'green',
    },
    [VOUCHER_TYPE_USAGE.BALANCE]: {
        label: voucherTypesMessages.balance,
        icon: ICON_MAP.INVOICE,
        theme: 'blue',
    },
};

export const VOUCHER_USAGE_MAP: Record<VOUCHER_TYPE_USAGE, { id: string; defaultMessage: string }> = {
    [VOUCHER_TYPE_USAGE.SINGLE]: voucherTypesMessages.single,
    [VOUCHER_TYPE_USAGE.BALANCE]: voucherTypesMessages.balance,
};
